import cx from 'classnames';
import { useCallback, useMemo, useState } from 'react';
import { Scrollbar } from 'react-scrollbars-custom';
import type { ScrollState } from 'react-scrollbars-custom/dist/types/types';
import FiltersMenu from '@/FiltersMenu/FiltersMenu';
import AppliedFilters from '@/MainLayout/AppliedFilters';
import { BorderWrapper, ScrollContainer } from './Filters.styles';

const scrollContentProps = { className: '!p-0' };
const scrollThumbProps = { className: '!bg-grey-3' };
const useScrollTrackProps = (isScrollable: boolean, isScrolling: boolean) =>
  useMemo(
    () => ({
      className: cx(
        '!bg-grey-2 !block !w-[4px] hover:opacity-100 opacity-0 transition-opacity',
        {
          'opacity-100': isScrolling,
          'pointer-events-none': !isScrollable
        }
      )
    }),
    [isScrollable, isScrolling]
  );
const scrollWrapperProps = { className: '!right-0' };

export default function Filters() {
  const [isScrollable, setScrollable] = useState(false);
  const [isScrolling, setScrolling] = useState(false);

  const onScrollUpdate = useCallback<(scrollValues: ScrollState) => void>(v => {
    setScrollable(v.scrollYPossible);
  }, []);

  const onScrollStart = useCallback(() => {
    setScrolling(true);
  }, []);

  const onScrollStop = useCallback(() => {
    if (!isScrolling) return () => {};

    const t = setTimeout(() => {
      setScrolling(false);
    }, 1000);

    return () => clearTimeout(t);
  }, [isScrolling]);

  return (
    <ScrollContainer
      className={
        isScrollable ? undefined : 'border-b-transparent border-r-transparent'
      }
      data-qa="filters-aside"
    >
      <Scrollbar
        contentProps={scrollContentProps}
        onScrollStart={onScrollStart}
        onScrollStop={onScrollStop}
        onUpdate={onScrollUpdate}
        thumbYProps={scrollThumbProps}
        trackYProps={useScrollTrackProps(isScrollable, isScrolling)}
        wrapperProps={scrollWrapperProps}
      >
        <BorderWrapper
          className={
            isScrollable
              ? 'border-b-transparent border-r-transparent'
              : undefined
          }
        >
          <AppliedFilters />
          <FiltersMenu />
        </BorderWrapper>
      </Scrollbar>
    </ScrollContainer>
  );
}
